import { useState } from "react";
export var useDeleteUser = function () {
    var _a = useState(false), openModalDelete = _a[0], setOpenModalDelete = _a[1];
    var _b = useState(""), modalTitle = _b[0], setModalTitle = _b[1];
    var onSubmit = function () {
        console.log("onSubmit");
    };
    return {
        openModalDelete: openModalDelete,
        setOpenModalDelete: setOpenModalDelete,
        modalTitle: modalTitle,
        setModalTitle: setModalTitle,
        onSubmit: onSubmit,
    };
};
